import Practice, { Workstation } from "app/models/practice"
import { createSelector } from "reselect"
import State from "../state"

export const loading = (state: State): boolean => state.practice.loading

export const getWorkStations = (state: State): Workstation[] => state.practice.data?.workstations || []

export const getWorkStationById = (state: State, id: string): Workstation =>
  state.practice.data?.workstations.find(workstation => workstation.id === id)!

export const makeGetWorkStationById = (id: string) =>
  createSelector(getWorkStations, workstations => workstations.find(workstation => workstation.id === id)!)

export const getPractice = (state: State): Practice | undefined => state.practice.data

export const getPracticeFeatures = createSelector(getPractice, practice => practice?.features)

export const canExportToSDWorx = createSelector(getPractice, practice => practice?.features?.canExportToSDWorx)

export const showLeaveCounters = createSelector(getPractice, practice => practice?.features?.showLeaveCounters)

export const showAvailabilityTypes = createSelector(getPractice, practice => practice?.features?.showAvailabilityTypes)

export const hasLeaveEntitlements = createSelector(getPractice, (practice): boolean => {
  if (practice?.features?.leaveEntitlements) {
    return true
  }
  return false
})

export const getPracticeName = createSelector(getPractice, practice => practice?.name || "")
